import React from 'react'
import { useLocation } from 'react-router-dom'

import PriceLevelsForm from '../../components/PriceLevels/Form'
import Layout from '../../components/Layout'

const ItemDetails = () => {
  const location = useLocation()
  const currentPath = location.pathname
  const isNewPriceLEvelCreation = currentPath === '/price-levels/new'

  const layoutTitle = isNewPriceLEvelCreation
    ? 'Add a Price Level'
    : undefined

  return (
    <Layout
      backTo="/price-levels"
      iconType="back"
      isSidebar
      title={layoutTitle}
      mainContent={<PriceLevelsForm />}
    />
  )
}

export default ItemDetails
